"use strict";
/* eslint-disable */
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));
var _default = exports.default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M12 5.11a.9.9 0 0 1 .9.9v4.608c0 .265.215.48.48.48h4.608a.9.9 0 0 1 .893.787l.007.113a.9.9 0 0 1-.9.9H13.38a.48.48 0 0 0-.48.48v4.608a.9.9 0 0 1-.787.893l-.113.007a.9.9 0 0 1-.9-.9v-4.608a.48.48 0 0 0-.48-.48H6.012a.9.9 0 0 1-.893-.787l-.007-.113a.9.9 0 0 1 .9-.9h4.608a.48.48 0 0 0 .48-.48V6.01a.9.9 0 0 1 .787-.893L12 5.11Z"
})), "0 0 24 24", "Plus");